import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../layouts/Header";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { Col, Row } from "react-bootstrap";

import CardAddButton from "../../assets/icons/Pluswhite.svg";
import TemplateBuilderIcon from "../../assets/icons/TemplateBuilder.svg";
import "../../assets/styles/local/TemplateBuilder.css";
import { Button, Dropdown, Menu, Tabs } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

import { templateTypes, availableTemplates } from "../../redux/actions/action";
import TemplatesList from "../../components/TemplateBuilder/TemplatesList";
import TemplateTableList from "../../components/TemplateBuilder/TemplateTableList";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import grapesTemplateApi from "../../services/grapesTemplateApi";

const ensureArray = (value) => (Array.isArray(value) ? value : []);
const SYSTEM_OWNER_COMPANY_ID = "28830f30-b321-4662-a576-f23451677734";

const normalizeGrapesTemplateType = (value) => {
  const normalized = String(value || "Other").replace(/s$/i, "");
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};

const getGrapesTemplates = (response) => {
  const candidates = [response, response?.templates, response?.items, response?.results];
  const templates = candidates.find(Array.isArray) || [];

  return templates
    .map((item) => {
      const template = item?.template || item;
      const id = template?.id || template?.templateId || item?.id || item?.templateId;
      return id
        ? {
            ...template,
            id,
            templateName: template?.templateName || template?.name || "Untitled template",
            templateType: normalizeGrapesTemplateType(template?.templateType || template?.type),
          }
        : null;
    })
    .filter(Boolean);
};

const mergeTemplates = (...templateLists) => {
  const byId = new Map();
  templateLists.flat().forEach((template) => {
    if (template?.id) byId.set(template.id, template);
  });
  return Array.from(byId.values());
};

const grapesTemplatesForTab = (templates, tab) =>
  templates.filter((template) => {
    const type = template.templateType;
    return (
      (tab === "invoices" && type === "Invoice") ||
      (tab === "stock" && type === "Stock") ||
      (tab === "quotes" && type === "Quote") ||
      (tab === "emails" && type === "Email") ||
      (tab === "others" && ["Other", "Checklist"].includes(type))
    );
  });

const TemplateBuilder = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { TabPane } = Tabs;

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Template-Builder-List").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [hover, setHover] = useState(false);
  const [addTemplateAction, setAddTemplateAction] = useState(false);
  const [availableTemplateTypes, setAvailableTemplateTypes] = useState([]);
  const [activeTab, setActiveTab] = useState("templates");

  const [formsTemplateList, setFormsTemplateList] = useState([]);
  const [stocksTemplateList, setStocksTemplateList] = useState([]);
  const [invoiceTemplateList, setInvoiceTemplateList] = useState([]);
  const [quotesTemplateList, setQuotesTemplateList] = useState([]);
  const [emailTemplateList, setEmailTemplateList] = useState([]);
  const [othersTemplateList, setOthersTemplateList] = useState([]);
  const [grapesTemplates, setGrapesTemplates] = useState([]);
  const companyId = window.localStorage.getItem("companyid");
  const isSystemOwner = companyId === SYSTEM_OWNER_COMPANY_ID;

  const typesOfTemplates = useSelector((data) => data.user.templateTypes);
  const availalableTemplateList = useSelector(
    (data) => data.user.availableTemplates,
  );

  useEffect(() => {
    dispatch(templateTypes());
    dispatch(availableTemplates());
  }, []);

  useEffect(() => {
    let active = true;

    Promise.all([
      grapesTemplateApi.list().then(getGrapesTemplates),
      grapesTemplateApi.effectiveNotificationTemplates().then(getGrapesTemplates).catch(() => []),
    ])
      .then(([templates, effectiveNotificationTemplates]) => {
        if (active) setGrapesTemplates(mergeTemplates(templates, effectiveNotificationTemplates));
      })
      .catch(() => active && setGrapesTemplates([]));

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (typesOfTemplates && typesOfTemplates.status) {
      console.log(typesOfTemplates.message);
      setAvailableTemplateTypes(ensureArray(typesOfTemplates.data));

      console.log(typesOfTemplates.data);
    }
  }, [typesOfTemplates]);

  useEffect(() => {
    if (availalableTemplateList && availalableTemplateList.status) {
      let data = availalableTemplateList.data;
      console.log(data);
      setFormsTemplateList(ensureArray(data?.forms));
      setStocksTemplateList(ensureArray(data?.stocks));
      setInvoiceTemplateList(ensureArray(data?.invoices));
      setQuotesTemplateList(ensureArray(data?.quotes));
      setEmailTemplateList(ensureArray(data?.emails));
      setOthersTemplateList(ensureArray(data?.others));
    }
  }, [availalableTemplateList]);

  const handleMenuClick = (e) => {};

  const handleRefresh = () => {
    dispatch(availableTemplates());
    Promise.all([
      grapesTemplateApi.list().then(getGrapesTemplates),
      grapesTemplateApi.effectiveNotificationTemplates().then(getGrapesTemplates).catch(() => []),
    ])
      .then(([templates, effectiveNotificationTemplates]) =>
        setGrapesTemplates(mergeTemplates(templates, effectiveNotificationTemplates)),
      )
      .catch(() => {});
  };

  const createWorkspaceOverride = async (template) => {
    try {
      const result = await grapesTemplateApi.createWorkspaceOverride(template.id || template.templateId);
      const created = result?.template || result;
      const id = created?.id || created?.templateId;
      if (id) history.push(`/grapes-template-builder/${id}`);
      else handleRefresh();
    } catch (error) {
      window.alert(error.message || "Unable to create a workspace template.");
    }
  };

  const revertWorkspaceOverride = async (template) => {
    try {
      await grapesTemplateApi.revertWorkspaceOverride(template.id || template.templateId);
      handleRefresh();
    } catch (error) {
      window.alert(error.message || "Unable to revert to the system template.");
    }
  };

  const setGrapesDefault = async (template) => {
    try {
      await grapesTemplateApi.setDefault(template.id || template.templateId);
      handleRefresh();
    } catch (error) {
      window.alert(error.message || "Unable to set the default template.");
    }
  };

  const duplicateGrapesTemplate = async (template) => {
    try {
      const result = await grapesTemplateApi.duplicate(template.id || template.templateId);
      const duplicated = result?.template || result;
      const id = duplicated?.id || duplicated?.templateId;
      handleRefresh();
      if (id) history.push(`/grapes-template-builder/${id}`);
    } catch (error) {
      window.alert(error.message || "Unable to duplicate the template.");
    }
  };

  const menu = (
    <Menu
      onClick={handleMenuClick}
      style={{ padding: "1rem 2.5rem", marginTop: "-3.2rem", height: "400px" }}
    >
      <div
        disabled
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0",
          marginBottom: "40px",
        }}
      >
        {/* Choose the type of template &nbsp;&nbsp;&nbsp; */}
        {t("Choose the type of template")} &nbsp;&nbsp;&nbsp;
        <CloseCircleOutlined onClick={() => setAddTemplateAction(false)} />
      </div>
      {availableTemplateTypes &&
        availableTemplateTypes.map((option, index) => (
          <Menu.Item
            key={option?.templateTypeId}
            className="template-options"
            onClick={() => {
              history.push({
                pathname: "/grapes-template-builder",
                search: `?type=${normalizeGrapesTemplateType(option?.templateTypeName)}`,
              });
            }}
          >
            <div className="d-flex justify-content-center">
              <div style={{ display: "flex", width: "4vw" }}>
                {/* <img
                  src={
                    option?.templateIcon && option?.templateIcon !== ""
                      ? require(`../../assets/icons/TemplateBuilder/${option?.templateIcon}`)
                      : require(`../../assets/icons/TemplateBuilder/default.svg`)
                  }
                  alt={option?.templateTypeName + " Dynamic icon"}
                  style={{ width: "14px", marginBottom: "5px" }}
                /> */}
                &nbsp; &nbsp;{" "}
                <strong className="mt-2">{option?.templateTypeName}</strong>
              </div>
            </div>
          </Menu.Item>
        ))}
    </Menu>
  );

  return (
    <>
      {/* Header Section for path display */}
      <Header
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/settings");
              }}
            >
              {/* Settings */}
              {t("Settings")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Templates */}
              {t("Templates")}
            </p>
          </div>
        }
      />

      {/* Main action Button */}
      <div className="ps-4 pe-4">
        <Row>
          <Col xl={9} lg={8} md={6} sm={12}></Col>
          <Col xl={3} lg={4} md={6} sm={12} className="add-col-item ">
            <Dropdown overlay={menu} open={addTemplateAction}>
              <div
                className="d-flex add-buttons ms-4"
                style={{
                  borderRadius: "12px",
                  width: "196px",
                  height: "51px",
                  fontSize: "16px",
                  gap: "14px",
                }}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setAddTemplateAction(true)}
              >
                {!hover && (
                  <img
                    src={TemplateBuilderIcon}
                    className="add-template"
                    alt="Add Icon"
                  />
                )}
                {hover && (
                  <img
                    src={CardAddButton}
                    className="add-template"
                    alt="Add Icon"
                  />
                )}
                {/* &nbsp;&nbsp;Add New */}
                &nbsp;&nbsp;{t("Add new")}
              </div>
            </Dropdown>
          </Col>
        </Row>

        <div id="ascTemplate">
          <Tabs
            activeKey={activeTab}
            style={{ width: "100%" }}
            onTabClick={(key) => {
              setActiveTab(key);
            }}
            className="templates-tab gap-2"
          >
            {/* Templates Tab */}
            <TabPane
              // tab="Templates"
              tab={t("Templates")}
              key="templates"
              className="min-height-60 p-3"
            >
              <TemplatesList />
            </TabPane>

            {/* Forms Template List Tab */}
            {/* <TabPane
              // tab="Forms"
              tab={t("Forms")}
              key="forms"
              className="min-height-60 p-3"
            >
              <TemplateTableList
                data={formsTemplateList}
                editRoute=""
                refreshData={handleRefresh}
                // header="All forms"
                header={t("All Forms ")}
              />
            </TabPane> */}

            {/* Invoice Template List Tab */}
            <TabPane
              // tab="Invoices"
              tab={t("Invoices")}
              key="invoices"
              className="min-height-60 p-3"
            >
              <TemplateTableList
                data={invoiceTemplateList}
                grapesTemplates={grapesTemplatesForTab(grapesTemplates, "invoices")}
                editRoute="/invoice-builder/"
                grapesEditRoute="/grapes-template-builder/"
                refreshData={handleRefresh}
                // header="All Invoices, Credits and Proforma"
                header={t("All Invoices, Credits and Proforma")}
              />
            </TabPane>

            {/* Stock Template List Tab */}
            <TabPane
              // tab="Stock"
              tab={t("Stock ")}
              key="stock"
              className="min-height-60 p-3"
            >
              <TemplateTableList
                data={stocksTemplateList}
                grapesTemplates={grapesTemplatesForTab(grapesTemplates, "stock")}
                editRoute="/stock-builder/"
                grapesEditRoute="/grapes-template-builder/"
                refreshData={handleRefresh}
                // header="All Stocks"
                header={t("All Stocks ")}
              />
            </TabPane>

            {/* Quotes Template List Tab */}
            <TabPane
              //  tab="Quotes"
              tab={t("Quotes ")}
              key="quotes"
              className="min-height-60 p-3"
            >
              <TemplateTableList
                data={quotesTemplateList}
                grapesTemplates={grapesTemplatesForTab(grapesTemplates, "quotes")}
                editRoute="/quote-builder/"
                grapesEditRoute="/grapes-template-builder/"
                refreshData={handleRefresh}
                // header="All Quotes"
                header={t("All Quotes ")}
              />
            </TabPane>

            {/* Emails Template List Tab */}
            <TabPane
              //  tab="Emails"
              tab={t("Emails ")}
              key="emails"
              className="min-height-60 p-3"
            >
              <TemplateTableList
                data={emailTemplateList}
                grapesTemplates={grapesTemplatesForTab(grapesTemplates, "emails")}
                editRoute="/email-builder/"
                grapesEditRoute="/grapes-template-builder/"
                refreshData={handleRefresh}
                readOnlySystemTemplates={!isSystemOwner}
                onCreateWorkspaceOverride={!isSystemOwner ? createWorkspaceOverride : undefined}
                onRevertWorkspaceOverride={!isSystemOwner ? revertWorkspaceOverride : undefined}
                onSetGrapesDefault={setGrapesDefault}
                onDuplicateGrapesTemplate={duplicateGrapesTemplate}
                // header="All Emails"
                header={t("All Emails ")}
              />
            </TabPane>

            {/* Others Template List Tab */}
            <TabPane
              //  tab="Others"
              tab={t("Others")}
              key="others"
              className="min-height-60 p-3"
            >
              <TemplateTableList
                data={othersTemplateList}
                grapesTemplates={grapesTemplatesForTab(grapesTemplates, "others")}
                editRoute="/others-builder/"
                grapesEditRoute="/grapes-template-builder/"
                refreshData={handleRefresh}
                // header="All Others"
                header={t("All Others")}
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default TemplateBuilder;
